import classNames from 'classnames'
import React, { PureComponent } from 'react'

import aspireLogoBlack from './aspire-logo_black.svg'
import aspireLogoBlackNoClaim from './aspire-logo_black_no-claim.svg'
import aspireLogoColor from './aspire-logo_color.svg'
import aspireLogoColorNoClaim from './aspire-logo_color_no-claim.svg'
import aspireLogoWhite from './aspire-logo_white.svg'
import aspireLogoWhiteNoClaim from './aspire-logo_white_no-claim.svg'

import './aspire-logo.scss'

type Props = {
  size: AspireLogoSizes
  color: AspireLogoColors
  className?: string
  altTitle?: string
  noClaim?: boolean
}

type AspireLogoColors = 'color' | 'black' | 'white'

type AspireLogoSizes = 'mini' | 'small' | 'large'

const sourceImageMapper = {
  color: aspireLogoColor,
  colorNoClaim: aspireLogoColorNoClaim,
  black: aspireLogoBlack,
  blackNoClaim: aspireLogoBlackNoClaim,
  white: aspireLogoWhite,
  whiteNoClaim: aspireLogoWhiteNoClaim,
}

const sizeClassMapper = {
  mini: 'aspire-logo--mini',
  small: 'aspire-logo--small',
  large: 'aspire-logo--large',
}

export class AspireLogo extends PureComponent<Props> {
  render() {
    const { size, color, className, altTitle, noClaim } = this.props

    const logoClasses = classNames('aspire-logo', sizeClassMapper[size], className)
    const imageClasses = classNames('aspire-logo__image')
    const altTitleDefault = 'aspire logo'

    return (
      <div className={logoClasses}>
        <img className={imageClasses} src={getSourceImage(color, noClaim)} alt={altTitle || altTitleDefault} />
      </div>
    )
  }
}

function getSourceImage(color: string, noClaim?: boolean) {
  const sourceImage = color + (noClaim ? 'NoClaim' : '')

  return sourceImageMapper[sourceImage]
}



// WEBPACK FOOTER //
// ./src/app/shared/components/aspire-logo/aspire-logo.component.tsx